var map = {
	"./AHYR7549.jpg": 2834,
	"./AIZU9492.jpg": 8158,
	"./AKSV7423.jpg": 5342,
	"./ALLA6690.jpg": 6204,
	"./AVAH2291.jpg": 1197,
	"./BFWV7123.jpg": 8843,
	"./BPZP7914.jpg": 3630,
	"./CJMA0169.jpg": 4826,
	"./CJMC0948.jpg": 4667,
	"./CQXD6238.jpg": 5712,
	"./FAUA9203.jpg": 4446,
	"./IPRN9313.jpg": 4150,
	"./KDDJ9712.jpg": 2723,
	"./MBZT6835.jpg": 9900,
	"./MSMF2911.jpg": 7853,
	"./NAGD6213.jpg": 2811,
	"./OIAG2220.jpg": 3571,
	"./OKLO7980.jpg": 452,
	"./OTWU2334.jpg": 8932,
	"./PGSH0774.jpg": 1085,
	"./TOFK8373.jpg": 8898,
	"./UNCA0273.jpg": 2792,
	"./UNZC3520.jpg": 7771,
	"./VSDN0787.jpg": 574,
	"./biscotti-pasta-frolla.jpg": 8217,
	"./colac.jpg": 6767,
	"./colacei-cu-mac.jpg": 5458,
	"./colacei-cu-mac_ssrrbv7r.jpg": 5898,
	"./colaci-pentru-sarbatori.jpg": 6391,
	"./la-placinte-banner.jpg": 8124,
	"./sarmale.jpg": 9744,
	"./sfoglie-al-forno-con-la-carne.jpg": 4436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5843;